export default __webpack_public_path__ + "static/media/car.23e13d77.png";